module.exports = __webpack_public_path__ + "img/38.518792d2.jpg";